import {
  OutboundAllowlistCreateDTO,
  OutboundAllowlistInterface,
  OutboundAllowlistKind,
  OutboundAllowlistPreview,
  OutboundAllowlistSnapshotEntry,
  OutboundGateStatus
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

/** Studio-side client for the Swivl-admin outbound allowlist (ENG-3113, Gate 2). */
export class OutboundAllowlistAPI {
  static async list() {
    return APIService.Server.get<OutboundAllowlistInterface[]>("/outbound-allowlist");
  }

  /** Internal: the kind + value snapshot a database-less process feeds its Outbound Gate with (ENG-3373). */
  static async snapshot() {
    return APIService.Server.get<OutboundAllowlistSnapshotEntry[]>("/outbound-allowlist/snapshot");
  }

  static async status() {
    return APIService.Server.get<OutboundGateStatus>("/outbound-allowlist/status");
  }

  static async preview(kind: OutboundAllowlistKind, value: string) {
    return APIService.Server.get<OutboundAllowlistPreview>(
      `/outbound-allowlist/preview?kind=${encodeURIComponent(kind)}&value=${encodeURIComponent(value)}`
    );
  }

  static async add(dto: OutboundAllowlistCreateDTO) {
    return APIService.Server.post<OutboundAllowlistInterface>("/outbound-allowlist", dto);
  }

  static async remove(id: number) {
    return APIService.Server.delete<void>(`/outbound-allowlist/${id}`);
  }
}
